export enum Region {
  'US' = 1,
  'CA' = 2,
  'MX' = 3,
}
